var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoinColored = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "coin"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M12.25 5.54199C12.25 6.99174 9.89949 8.16699 7 8.16699M12.25 5.54199C12.25 4.09224 9.89949 2.91699 7 2.91699C4.1005 2.91699 1.75 4.09224 1.75 5.54199M12.25 5.54199V8.75033C12.25 10.039 9.89949 11.0837 7 11.0837M7 8.16699C4.1005 8.16699 1.75 6.99174 1.75 5.54199M7 8.16699V11.0837M1.75 5.54199V8.75033C1.75 10.039 4.1005 11.0837 7 11.0837M4.08333 10.6907V7.72496M9.91667 10.6907V7.72496M9.33333 5.54199C9.33333 6.02524 8.28866 6.41699 7 6.41699C5.71134 6.41699 4.66667 6.02524 4.66667 5.54199C4.66667 5.05874 5.71134 4.66699 7 4.66699C8.28866 4.66699 9.33333 5.05874 9.33333 5.54199Z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoinColored);
export default ForwardRef;